import { signOut } from '@firebase/auth';
import { Logout, Storefront } from '@mui/icons-material';
import { IconButton, ListItemIcon, Menu, MenuItem, Box, Typography, Divider, Avatar } from '@mui/material';
import { MouseEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Worker } from '../../apiTypes';
import { menuProps } from '../../constants/styles';
import { t } from '../../constants/translations';
import { useLocale } from '../../contexts/locale.context';
import { useUser } from '../../contexts/user.context';
import { auth } from '../../firebase';
import { stringToColor } from '../../utils/stringToColor';

type Props = {
  worker?: DbDocument<Worker>;
  restaurantName?: string;
  isMultyUser?: boolean;
  clearPin?: () => void;
};

const ProfileMenu = ({ worker, restaurantName, isMultyUser, clearPin }: Props) => {
  // const [darkMode, setDarkMode] = useLocalStorage<string>('darkMode');

  const { lang } = useLocale();
  const { user } = useUser();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const goToMyRestaurants = () => {
    navigate('/');
  };

  const logout = () => {
    if (isMultyUser && clearPin) {
      clearPin();
    } else {
      signOut(auth);
    }
  };

  return (
    <>
      <IconButton onClick={handleClick} size="small" sx={{ position: 'relative' }}>
        <Avatar
          src={worker ? worker.photoUrl : user.photoURL}
          alt={worker ? worker.name : user.displayName}
          sx={{ bgcolor: stringToColor(worker ? worker.name : user.displayName) }}
        />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{ sx: menuProps }}
        MenuListProps={{
          sx: { p: 0, li: { m: 1 } },
        }}
      >
        {restaurantName && (
          <div>
            <Box sx={{ my: 2, mx: 3 }}>
              <Typography textAlign="center">{restaurantName}</Typography>
            </Box>
            <Divider sx={{ my: 1, borderColor: (t) => t.palette.grey[200] }} />
          </div>
        )}

        <Box sx={{ my: 2, mx: 3 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
            {worker ? worker.name : user.displayName}
          </Typography>
          <Typography color="GrayText">{worker?.role && t[worker.role][lang]}</Typography>
        </Box>

        {/* <Divider sx={{ my: 1, borderColor: (t) => t.palette.grey[200] }} />

        <Box sx={{ m: 2 }}>
          <FormControlLabel
            control={
              <Switch
                checked={Boolean(darkMode)}
                onChange={(event) => setDarkMode(event.target.checked ? 'true' : undefined)}
              />
            }
            label={t.dark_theme[lang]}
          />
        </Box> */}

        <Divider sx={{ my: 1, borderColor: (t) => t.palette.grey[200] }} />

        {!isMultyUser && (
          <MenuItem onClick={goToMyRestaurants}>
            <ListItemIcon>
              <Storefront fontSize="small" />
            </ListItemIcon>
            {t.my_restaurants[lang]}
          </MenuItem>
        )}

        <MenuItem onClick={logout}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          {t.sing_out[lang]}
        </MenuItem>
      </Menu>
    </>
  );
};

export default ProfileMenu;
